import { render, staticRenderFns } from "./StreamChatMessage.vue?vue&type=template&id=f111cda8&scoped=true&"
import script from "./StreamChatMessage.vue?vue&type=script&lang=js&"
export * from "./StreamChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./StreamChatMessage.vue?vue&type=style&index=0&id=f111cda8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f111cda8",
  null
  
)

export default component.exports